/* eslint-disable @nx/enforce-module-boundaries */
import { Button } from '@mybridge/ui/button';
import { Heading } from '@mybridge/ui/heading';
import { HStack, Stack, VStack } from '@mybridge/ui/layout';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@mybridge/ui/modal';
import { Radio, RadioGroup } from '@mybridge/ui/radio';
import { Text } from '@mybridge/ui/text';
import { useContext, useMemo, useState } from 'react';
import { getUserFullName } from 'v4/lib/commons';
import { PostBoxContext } from '../../context';
import { useDispatch } from 'react-redux';
import { reportPublicCompany } from 'v4/store/actions/companyPages.actions';
import { StackDivider, useToast } from '@chakra-ui/react';
import { CheckGreen, ChevronRight } from '@mybridge/icons';
import { CheckIcon } from '@chakra-ui/icons';
import { Divider } from '@mybridge/ui';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const CompanyBlockReportModal = ({ companyPageDetail, ...props }) => {
  const dispatch = useDispatch();
  const [reason, setReason] = useState('');
  const [reportSuccess, setReportSuccess] = useState(false);
  const toast = useToast();
  const { t } = useTranslator();

  const blockReportReasons = useMemo(() => [
    {
      title: t('profileNetwork.pretendingToBeSomeoneElse') || 'Pretending to be someone else',
    },
    {
      title: t('profileNetwork.fakeAccount') || 'Fake account',
    },
    {
      title: t('profileNetwork.postingInappropriateThings') || 'Posting inappropriate things',
    },
    {
      title: t('profileNetwork.harassmentOrBullying') || 'Harrasment or bullying',
    },
    {
      title: t('profileNetwork.somethingNotRight') || "Something's not right",
    },
  ]);

  const handleBlockReport = (value) => {
    setReason(value);
    const payload = {
      company_id: companyPageDetail?.id,
      message: value,
    };

    dispatch(reportPublicCompany(payload)).then((res) => {
      if(res?.payload?.message === 'Reported Successfully'){
        setReportSuccess(true);
      } else {
        toast({
          title: res?.payload?.message,
          status: 'error',
          position: 'top',
          duration: 5000,
          isClosable: true,
        })
        props?.onClose()
      }
    });
  };
  return (
    <>
      <Modal size={["xs","xl"]} {...props}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign="center" fontWeight="400">
            <ModalCloseButton />
            {t('profilePhotosVideos.report') || "Report"} {companyPageDetail?.name}
          </ModalHeader>
          {!reportSuccess && (
            <ModalBody>
              <Stack>
                <Stack>
                  <Heading
                    fontSize="18px"
                    fontWeight="400"
                    color="brandPrimary.500"
                  >
                    {t('profileNetwork.pleaseSelectAProblem') || "Please select a problem"}
                  </Heading>
                  <Text>
                    {t('profileNetwork.immediateDangerWarning') || "If someone is in immediate danger, get help before reporting to myBridge. Don't wait."}
                  </Text>
                </Stack>
        
                <Stack
                  spacing={6}
                  align="stretch"
                  my={4}
                  // divider={<StackDivider borderColor="gray.200" />}
                >
                  {blockReportReasons?.map?.((brr, index) => (
                    // <Radio key={index} value={brr?.title}>
                    //   {brr?.title}
                    // </Radio>
                    <HStack
                      key={index}
                      value={brr?.title}
                      justifyContent="space-between"
                      cursor="pointer"
                      onClick={() => handleBlockReport(brr?.title)}
                    >
                      <Text>{brr?.title}</Text>
                      <ChevronRight width="7" />
                    </HStack>
                  ))}
                </Stack>
              </Stack>
            </ModalBody>
          )}
          {reportSuccess && <ModalBody>
            <VStack gap={4}>
              <CheckGreen width="25" height="25" />
              <Heading
                fontSize="20px"
                fontWeight="400"
                color="brandPrimary.500"
              >
                {t('profilePhotosVideos.report') || "Report"} {companyPageDetail?.name}
              </Heading>

              <Text>{t('profileNetwork.thanksForReportingCompany') || "Thanks for reporting this company"}</Text>

              <HStack p="5px 10px" bg="#E8E8E8" borderRadius="full">
                <CheckIcon /> <Text>{reason}</Text>
              </HStack>
              <Divider />
              <Button
                onClick={() => {setReportSuccess(false); props?.onClose()}}
                variant="primary"
                borderRadius="full"
                w="100%"
                // isLoading={blockReportLoading}
              >
                {t('buttons.done') || "Done"}
              </Button>
            </VStack>
          </ModalBody>}
          
        </ModalContent>
      </Modal>
    </>
  );
};
